import React, { useEffect, useState } from 'react';
import axios from "axios";
import ZeusTable2 from 'components/tables/ZeusTable2.tsx'
import toast, { Toaster } from 'react-hot-toast';
import './MyLicense.scss';
import { ShowDate, RowActions, SingleAction} from 'components/tables/tableTools';
import LicenseRequestForm from './LicenseRequestForm';
import LicenseDetails from './LicenseDetails';


import { createColumnHelper } from '@tanstack/react-table'

export default function MyLicense() {

  
  const [data, setData] = useState({})
  const [showLicenseRequestForm, setShowLicenseRequestForm] = useState(false)
  const [iteration, setIteration] = useState(0)
  const [showLicenseDetails, setShowLicenseDetails] = useState(false)
  const [selectedLicenseId, setSelectedLicenseId] = useState()

  const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
  });
  
  // Table data
  async function getLicenseData() {
    try {
      const resLicenses = await API.post("/users/licenses");
      setData(resLicenses.data);
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
    }
  }
  useEffect(() => {
    getLicenseData()
  }, [])
  
  const columnHelper = createColumnHelper()
  const columns = [
    columnHelper.display({
      id: 'Actions',
      cell: info => <SingleAction id={info.row.original.id} label="Open" function={openLicenseDetails} />,
    }),
    columnHelper.accessor(row => row.company, {
      id: 'Company',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Company</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.id, {
      id: 'ID',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>ID</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.description, {
      id: 'Description',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Description</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.ltype, {
      id: 'Type',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Type</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.option_key, {
      id: 'Option Key',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>License Code</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.expire_datetime, {
      id: 'Expery Date',
      header: () => <span>Expery Date</span>,
      cell: props => <ShowDate row={props.row.original.expire_datetime} />,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => row.status, {
      id: 'Status',
      cell: info => <i>{info.getValue()}</i>,
      header: () => <span>Status</span>,
      footer: info => info.column.id,
    }),

//    columnHelper.accessor('licenseCode', {
//      header: () => 'License Code',
//      cell: info => info.renderValue(),
//      footer: info => info.column.id,
//    }),

//    columnHelper.accessor('expires', {
//      header: () => <span>Expiry Date</span>,
//      footer: info => info.column.id,
//    })
  ]

  const closeModal = () => {
    //setShowUserDetails(false)
    setShowLicenseDetails(false)
    document.body.classList.remove('modal-open');
    setIteration(1 + iteration)
  }

  const openLicenseDetails = () => {
    document.body.classList.add('modal-open');
    setShowLicenseDetails(true)
  };

  const openLicenseRequestForm = () => {
    document.body.classList.add('modal-open');
    setShowLicenseRequestForm(true)
  };

  const cancelLicenseRequest = () => {
    setShowLicenseRequestForm(false)
    closeModal()
  }

  const addLicenseRequest = (childData) => {
    console.log(childData)
    setShowLicenseRequestForm(false)
    const result = createLicenseRequest(childData)
  }

  const createLicenseRequest = async (profile) => {
    try {
      const resUser = await API.post("/create-license", profile);
      //toast.success("User saved")
      //getUsersData()
      return resUser.data;
    } catch (error) {
      console.log(error?.response?.data);
      toast.error(error?.response?.data)
      return error?.response?.data;
    }
  };

  return (
    <div>
      <div className="header pb-6">
        <div className="container-fluid">
          <div className="header-body">
            <div className="row align-items-center py-4">
              <div className="col-lg-6 col-7">
                <h2 className="h2 d-inline-block mb-0">My License</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt--6" style={{minHeight: '100vh'}}>
        <div className="card">
            <ZeusTable2
              columns={columns}
              data={data}
              create={openLicenseDetails}
              createLabel="Create License Request"
              refreshData={getLicenseData}
            />
        </div>
        { showLicenseRequestForm &&
          <LicenseRequestForm cancel={cancelLicenseRequest} confirm={addLicenseRequest}/> 
        }
        { showLicenseDetails &&
          <LicenseDetails userId={selectedLicenseId} closeForm={closeModal}/> 
        }
      </div>
    </div>
  )
}